import Botao from '@/components/Botao';
import CampoCheckbox from '@/components/Formulario/CampoCheckbox';
import CampoSenha from '@/components/Formulario/CampoSenha';
import CampoTexto from '@/components/Formulario/CampoTexto';
import AlertBox from '@/components/layout/AlertBox';
import HBox from '@/components/layout/HBox';
import VBox from '@/components/layout/VBox';
import ApiCall from '@/lib/apiCall';
import { useAuth } from '@/lib/useAuth';
import { mdiEmailOutline, mdiLockOutline, mdiArrowRight } from '@mdi/js';
import Icon from '@mdi/react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const FormLogin = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const s = new URLSearchParams(window.location.search);
  const redirPath = s.get('r') ?? '/';

  useEffect(() => {
    if (user) navigate(redirPath);
  }, [user, navigate, redirPath]);

  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [lembrar, setLembrar] = useState(true);

  const [loginError, setLoginError] = useState<string | null>(null);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoginError(null);

    try {
      const result = await ApiCall.post('/api/login', {
        username: usuario,
        password: senha,
      });
      setLoginError('');
      console.log('result', result);

      if (result.ok) navigate(redirPath);
      else setLoginError('Usuário ou senha inválidos');
    } catch (e) {
      setLoginError('Usuário ou senha inválidos');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <VBox gap={28}>
        {/* Cabeçalho */}
        <div>
          <p
            style={{
              fontSize: '0.7rem',
              fontWeight: '600',
              letterSpacing: '0.12em',
              color: 'var(--color-muted)',
              textTransform: 'uppercase',
              margin: '0 0 10px',
            }}
          >
            Entrar na conta
          </p>
          <h2 style={{ fontSize: '1.8rem', fontWeight: '700', color: '#0b2e5e', margin: '0 0 8px' }}>
            Bem-vindo de volta
          </h2>
          <p style={{ color: 'var(--color-muted)', margin: 0, fontSize: '0.95rem' }}>
            Acesse o painel da sua organização.
          </p>
        </div>

        {/* Campos */}
        <VBox gap={16}>
          <CampoTexto
            tabIndex={1}
            autoFocus
            label="E-mail corporativo"
            placeholder="seu@email.com.br"
            type="email"
            value={usuario}
            onChange={setUsuario}
            required
            prepend={<Icon path={mdiEmailOutline} size="18px" color="var(--fg-3)" />}
          />

          <div>
            <HBox stretch style={{ marginBottom: '6px' }}>
              <span style={{ fontSize: '0.875rem', fontWeight: '500', color: 'var(--color-body)' }}>Senha</span>
              <a
                href="#"
                style={{ fontSize: '0.875rem', color: '#2563eb', textDecoration: 'none' }}
                tabIndex={5}
              >
                Esqueci a senha
              </a>
            </HBox>
            <CampoSenha
              tabIndex={2}
              placeholder="••••••••"
              value={senha}
              onChange={setSenha}
              required
              prepend={<Icon path={mdiLockOutline} size="18px" color="var(--fg-3)" />}
            />
          </div>

          <CampoCheckbox
            text="Manter conectado neste dispositivo"
            value={lembrar}
            onChange={setLembrar}
            tabIndex={3}
          />
        </VBox>

        {loginError && <AlertBox variant="danger">{loginError}</AlertBox>}

        <Botao
          style={{ width: '100%' }}
          type="submit"
          variant="primary"
          tabIndex={4}
          icon={mdiArrowRight}
        >
          Entrar
        </Botao>

        {/* Rodapé */}
        <p style={{ textAlign: 'center', fontSize: '0.875rem', color: 'var(--color-muted)', margin: 0 }}>
          Ainda não tem conta?{' '}
          <a href="#" style={{ color: '#2563eb', fontWeight: '500', textDecoration: 'none' }}>
            Fale com vendas
          </a>
        </p>
      </VBox>
    </form>
  );
};
